import { BookingStateEnum } from '../../enums'
import { PublicBooking, PublicCancelBooking } from '../../models'

export const defaultBooking: PublicBooking = {
  firstname: '',
  lastname: '',
  companyname: '',
  email: '',
  phone: '',
  address: {
    street: '',
    postalCode: '',
    city: '',
  },
  additionalInfo: '',
  customFields: {},
  customerCustomConditions: [],
  amount: 2,
  room: '',
  state: {
    status: BookingStateEnum.OPEN,
  },
  origin: 'CUSTOMER',
  shift: 'any',
  employee: '',
  services: [],
  from: '',
  until: '',
  formattedDate: '',
  formattedTime: '',
}

export const defaultCancelBooking: PublicCancelBooking = {
  amount: 0,
  cancelThresholdAchieved: false,
  tenantId: '',
  id: '',
  state: BookingStateEnum.OPEN,
  firstname: '',
  lastname: '',
  formattedDate: '',
  formattedTime: '',
  employee: { id: '', mail: '', name: '', pictureUrl: '', vita: '' },
  services: [],
}
